// Local Typings
export interface Coords {
  bottom?: number;
  left?: number;
  right?: number;
  top?: number;
}

export function getCoords(el: HTMLElement): Coords {
  const position = el.getBoundingClientRect();

  return {
    bottom: position.top + el.offsetHeight,
    left: position.left,
    right: position.left + el.offsetWidth,
    top: position.top,
  };
}
